/**
 * Unified Environment Configuration for ReactApp
 * Single source of truth - uses runtime detection for API URL
 */

import { getApiBaseUrl } from './config/environment';

// Environment-based configuration
const environment = process.env.NODE_ENV || 'development';

// Get API URL using runtime detection (checks window.location.hostname)
const apiUrl = getApiBaseUrl();

const cfg = {
  environment,
  API_BASE: apiUrl,
  TENANT: process.env.REACT_APP_TENANT || "development",
};

export default cfg;